export default __webpack_public_path__ + "static/media/enseeiht.67c25b28.png";